import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IAppDataExportModal } from '../types/data-export.types';

interface AppDataExportInitialState {
  currentModal: IAppDataExportModal | null;
}

const appDataExportInitialState: AppDataExportInitialState = {
  currentModal: null,
};

export const appDataExport = createSlice({
  name: 'appDataExport',
  initialState: appDataExportInitialState,
  reducers: {
    setDataExportModal: (state, action: PayloadAction<IAppDataExportModal | null>) => {
      state.currentModal = action.payload;
    },
  },
});

export const { setDataExportModal } = appDataExport.actions;
